import React from "react";
import { Box, Grid, Typography, Divider, Container, IconButton, Link as MuiLink } from "@mui/material";
import { Facebook, Twitter, Instagram, LocalShipping, Phone, Email } from "@mui/icons-material";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        marginTop: "80px",
        background: "linear-gradient(180deg, #1a1a2e 0%, #0f0f1e 100%)",
        color: "white",
        padding: { xs: "60px 0 30px", md: "80px 0 40px" },
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "6px",
          background: "linear-gradient(90deg, #03A9F4 0%, #0277BD 50%, #025D9E 100%)",
        }
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={6}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Box sx={{ marginBottom: "24px" }}>
              <img
                src="/RCS-white.png"
                alt="RCS Express"
                style={{
                  width: "250px",
                  height: "auto",
                  filter: "brightness(1.2)",
                  marginBottom: "20px",
                }}
              />
            </Box>
            <Typography
              fontFamily="Montserrat"
              fontSize="15px"
              fontWeight={400}
              lineHeight={1.8}
              color="rgba(255, 255, 255, 0.8)"
              sx={{ marginBottom: "24px", paddingRight: { md: "20px" } }}
            >
              Your one stop solution to all your logistical needs. Headquartered
              in Lahore, we have been providing quality and professional
              International and Domestic Courier & Cargo services for over a
              decade.
            </Typography>
            
            {/* Contact Info */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <Phone sx={{ fontSize: "20px", color: "#0277BD" }} />
                <Typography fontFamily="Montserrat" fontSize="14px" color="rgba(255, 255, 255, 0.8)">
                  +92 301 6804252
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <Email sx={{ fontSize: "20px", color: "#0277BD" }} />
                <Typography fontFamily="Montserrat" fontSize="14px" color="rgba(255, 255, 255, 0.8)">
                  info@rcsxpress.com
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Services */}
          <Grid item xs={6} md={3}>
            <Typography
              fontFamily="Montserrat"
              fontSize="20px"
              fontWeight={700}
              lineHeight="32px"
              marginBottom="24px"
              sx={{
                background: "linear-gradient(135deg, #03A9F4 0%, #0277BD 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              SERVICES
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              {["International Services", "Air Freight", "Sea Freight", "Same Day Delivery", "Overnight", "Flyer Express", "Cash on Delivery"].map((service, index) => (
                <MuiLink
                  key={index}
                  href="#service"
                  underline="none"
                  sx={{
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "rgba(255, 255, 255, 0.7)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      color: "#03A9F4",
                      paddingLeft: "8px",
                    }
                  }}
                >
                  {service}
                </MuiLink>
              ))}
            </Box>
          </Grid>

          {/* About & Quick Links */}
          <Grid item xs={6} md={3}>
            <Typography
              fontFamily="Montserrat"
              fontSize="20px"
              fontWeight={700}
              lineHeight="32px"
              marginBottom="24px"
              sx={{
                background: "linear-gradient(135deg, #03A9F4 0%, #0277BD 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              COMPANY
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "30px" }}>
              {[
                { label: "About Us", href: "#about_us" },
                { label: "Our Services", href: "#service" },
                { label: "Track Shipment", href: "#" },
                { label: "Contact Us", href: "https://web.whatsapp.com/send?phone=923016804252" }
              ].map((link, index) => (
                <MuiLink
                  key={index}
                  href={link.href}
                  underline="none"
                  sx={{
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "rgba(255, 255, 255, 0.7)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      color: "#03A9F4",
                      paddingLeft: "8px",
                    }
                  }}
                >
                  {link.label}
                </MuiLink>
              ))}
            </Box>
          </Grid>

          {/* Newsletter & Social */}
          <Grid item xs={12} md={2}>
            <Typography
              fontFamily="Montserrat"
              fontSize="20px"
              fontWeight={700}
              lineHeight="32px"
              marginBottom="24px"
              sx={{
                background: "linear-gradient(135deg, #03A9F4 0%, #0277BD 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              FOLLOW US
            </Typography>
            <Box sx={{ display: "flex", gap: "12px", marginBottom: "24px" }}>
              {[
                { icon: <Facebook />, href: "#" },
                { icon: <Twitter />, href: "#" },
                { icon: <Instagram />, href: "#" }
              ].map((social, index) => (
                <IconButton
                  key={index}
                  href={social.href}
                  sx={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "6px",
                    background: "rgba(2, 119, 189, 0.1)",
                    border: "2px solid rgba(2, 119, 189, 0.3)",
                    color: "#0277BD",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      background: "linear-gradient(135deg, #03A9F4 0%, #0277BD 100%)",
                      color: "white",
                      transform: "translateY(-4px)",
                      boxShadow: "0 8px 24px rgba(2, 119, 189, 0.4)",
                    }
                  }}
                >
                  {social.icon}
                </IconButton>
              ))}
            </Box>
            
            {/* Trust Badge */}
            <Box
              sx={{
                padding: "16px",
                background: "rgba(2, 119, 189, 0.1)",
                borderRadius: "8px",
                border: "1px solid rgba(2, 119, 189, 0.2)",
                textAlign: "center",
              }}
            >
              <LocalShipping sx={{ fontSize: "32px", color: "#0277BD", marginBottom: "8px" }} />
              <Typography
                fontFamily="Montserrat"
                fontSize="12px"
                fontWeight={600}
                color="rgba(255, 255, 255, 0.9)"
              >
                Trusted Delivery
              </Typography>
              <Typography
                fontFamily="Montserrat"
                fontSize="10px"
                color="rgba(255, 255, 255, 0.6)"
              >
                Since 2010
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Bottom Bar */}
        <Box sx={{ marginTop: "60px" }}>
          <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.1)", marginBottom: "30px" }} />
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography
                fontFamily="Montserrat"
                fontSize="14px"
                fontWeight={500}
                color="rgba(255, 255, 255, 0.6)"
                textAlign={{ xs: "center", md: "left" }}
              >
                © {new Date().getFullYear()} RCS Worldwide Express. All rights reserved.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  gap: "24px",
                  justifyContent: { xs: "center", md: "flex-end" },
                  marginTop: { xs: "16px", md: 0 }
                }}
              >
                <MuiLink
                  href="#"
                  underline="none"
                  sx={{
                    fontFamily: "Montserrat",
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "rgba(255, 255, 255, 0.6)",
                    transition: "color 0.3s ease",
                    "&:hover": { color: "#03A9F4" }
                  }}
                >
                  Privacy Policy
                </MuiLink>
                <MuiLink
                  href="#"
                  underline="none"
                  sx={{
                    fontFamily: "Montserrat",
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "rgba(255, 255, 255, 0.6)",
                    transition: "color 0.3s ease",
                    "&:hover": { color: "#03A9F4" }
                  }}
                >
                  Terms of Service
                </MuiLink>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
